import { render, staticRenderFns } from "./PermissionsPopup.vue?vue&type=template&id=64fe75f7"
import script from "./PermissionsPopup.vue?vue&type=script&lang=js"
export * from "./PermissionsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports